goog.provide('el8.ptdata.model.note.muInfo');

goog.require('el8.model.base');

// ---------------------
// * VISIT NOTE MU INFO*
// ---------------------
(function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('transitionOfCare');
    _class.addBoolean('medsReconciled');
    _class.addDateTime('noteSummaryProvidedTime');

    _class.addBoolean('summaryOfCareProvided');
    _class.addBoolean('currentMedsDocumented', false, null); // nullable
    _class.addBoolean('patientReminder');

    _class.prototype.asSoyMap = function() {
        var m = {};
        m['transitionOfCare'] = this.getTransitionOfCare();
        m['isMedsReconciled'] = this.isMedsReconciled();
        m['isSummaryOfCareProvided'] = this.isSummaryOfCareProvided();
        m['isNoteSummaryProvided'] = !!this.getNoteSummaryProvidedTime();
        m['isCurrentMedsDocumented'] = this.isCurrentMedsDocumented();
        m['isPatientReminder'] = this.isPatientReminder();
        return m;
    };

    el8.ptdata.model.note.muInfo = function(spec) {
        return new _class(spec);
    };

})();

el8.ptdata.model.note.addMuInfoMethods = function(_class) {
    _class.prototype.getMeaningfulUseInfoItem = function(getter) {
        if (this.getMeaningfulUseInfo()) {
            return this.getMeaningfulUseInfo()[getter]();
        }
        return null;
    };
    _class.prototype.setMeaningfulUseInfoFromSpec = function(spec) {
        if (this.getMeaningfulUseInfo()) {
            this.getMeaningfulUseInfo().populate(spec);
        } else {
            var muInfo = el8.ptdata.model.note.muInfo(spec);
            this.setMeaningfulUseInfo(muInfo);
        }
    };
};


